import api from "./axiosConfig";
import { ScoreHistoryPoint } from "../types";

export interface ClientScoreSummary {
  clientId: string;
  clientName: string;
  currentEquifax: number;
  currentExperian: number;
  currentTransUnion: number;
  deltaEquifax: number | null;
  deltaExperian: number | null;
  deltaTransUnion: number | null;
  deltaAverage: number | null;
  lastUpdated: string | null;
}

export interface AddScoreSnapshotPayload {
  clientId: string;
  equifaxScore: number;
  experianScore: number;
  transUnionScore: number;
  recordedDate: string;
  notes?: string | null;
}

export interface AddScoreSnapshotResponse {
  period: string;
  createdAt: string;
  equifaxScore: number;
  experianScore: number;
  transUnionScore: number;
}

export interface ScoreEntryPayload {
  clientId: string;
  bureau: string;
  score: number;
  recordedAt: string;
}

export interface ScoreEntryResponse {
  id: string;
  clientId: string;
  bureau: string;
  score: number;
  period: string;
  createdAt: string;
}

export const scoresApi = {
  getHistory: async (clientId: string, rangeDays = 365 * 3): Promise<ScoreHistoryPoint[]> => {
    const { data } = await api.get<ScoreHistoryPoint[]>("/scores", {
      params: { clientId, rangeDays },
    });
    return data;
  },

  getSummary: async (): Promise<ClientScoreSummary[]> => {
    const { data } = await api.get<ClientScoreSummary[]>("/scores/summary");
    return data;
  },

  addSnapshot: async (payload: AddScoreSnapshotPayload): Promise<AddScoreSnapshotResponse> => {
    const { data } = await api.post<AddScoreSnapshotResponse>("/scores", {
      clientId: payload.clientId,
      equifaxScore: payload.equifaxScore,
      experianScore: payload.experianScore,
      transUnionScore: payload.transUnionScore,
      recordedDate: payload.recordedDate,
      notes: payload.notes ?? undefined,
    });
    return data;
  },

  /** Single-bureau monthly row (legacy). */
  addBureauEntry: async (payload: ScoreEntryPayload): Promise<ScoreEntryResponse> => {
    const { data } = await api.post<ScoreEntryResponse>("/scores/bureau", {
      clientId: payload.clientId,
      bureau: payload.bureau,
      score: payload.score,
      recordedAt: payload.recordedAt,
    });
    return data;
  },
};
